import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { showErrorMessage } from '@/shared/components/toast-system';
import * as constants from '../constants';

const FacebookCallback = () => {
  const navigate = useNavigate();
  const fallbackRoute = constants.ENABLE_NEW_UI ? '/channels' : constants.ROUTE_CHANNELS;

  useEffect(() => {
    const alreadyProcessed = sessionStorage.getItem('facebook_callback_processed') === 'true';

    if (alreadyProcessed) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token') || urlParams.get('facebook_token');
    const pagesParam = urlParams.get('pages') || urlParams.get('facebook_pages');
    const errorParam = urlParams.get('error') || urlParams.get('facebook_error');

    if (errorParam) {
      showErrorMessage('Facebook connection failed: ' + decodeURIComponent(errorParam));
      navigate(fallbackRoute);
      return;
    }

    if (token && pagesParam) {
      sessionStorage.setItem('facebook_callback_processed', 'true');

      sessionStorage.setItem('facebook_auth_token', token);
      sessionStorage.setItem('facebook_auth_pages', pagesParam);
      sessionStorage.setItem('facebook_auth_pending', 'true');

      setTimeout(() => {
        sessionStorage.removeItem('facebook_callback_processed');
      }, 1000);

      const returnUrl = sessionStorage.getItem('facebook_auth_return_url');
      sessionStorage.removeItem('facebook_auth_return_url');

      if (returnUrl) {
        navigate(returnUrl);
      } else {
        navigate(fallbackRoute);
      }
    } else if (window.location.search) {
      showErrorMessage('Invalid Facebook callback parameters');
      navigate(fallbackRoute);
    } else {
      navigate(fallbackRoute);
    }
  }, [navigate, fallbackRoute]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div className="spinner" style={{ fontSize: '48px' }}>
        <i className="bx bx-loader-alt bx-spin"></i>
      </div>
      <p style={{ marginTop: '20px' }}>Processing Facebook connection...</p>
    </div>
  );
};

export default FacebookCallback;
